<template>
  <div>
    <b-row v-if="loading" class="d-flex justify-content-center">
      <b-spinner
        style="width: 3rem; height: 3rem;"
        variant="primary"
        label="Spinning"
      ></b-spinner>
    </b-row>
    <b-row
      v-if="product.units.length == 0 && !loading"
      class="pl-3 pr-3 text-center"
    >
      <b-col>
        <b-alert show variant="warning">No stock available </b-alert>
      </b-col>
    </b-row>
    <b-row v-if="product.units.length != 0 && !loading">
      <b-col cols="6" class="text-center ">
        <h4 class="font-poppins">Units</h4>

        <div v-for="(unit, unitIndex) in product.units" :key="unitIndex">
          <div
            @click="selectUnit(unit)"
            :class="
              unit.id == selectedUnit.id ? 'unit m-1 selected' : 'unit m-1'
            "
          >
            {{ unit.name }}
          </div>
        </div>
      </b-col>
      <b-col cols="6" class="text-center">
        <h4 class="font-poppins">Batch</h4>
        <b-row v-if="isStockAvailable(selectedUnit.batches)">
          <b-col cols="4" class="pt-1">
            <b-form-checkbox
              size="lg"
              @change="updateMinPrice(minPriceVisible)"
              v-model="minPriceVisible"
            >
            </b-form-checkbox>
          </b-col>
          <h6 style="margin-left: -41px;">Set Current Price</h6>
        </b-row>
        <div
          v-for="(batch, batchIndex) in selectedUnit.batches"
          :key="batchIndex"
        >
          <b-row v-if="batch.available_stock > 0">
            <b-col cols="10">
              <div>
                <div
                  @click="batch.isBargained ? '' : selectBatch(batch)"
                  :class="
                    batch.id == selectedBatch.id
                      ? 'batch m-1 selected'
                      : 'batch m-1'
                  "
                >
                  <b-row
                    @click.stop="batch.isBargained ? '' : selectBatch(batch)"
                  >
                    <b-col>
                      <div class="font-poppins">{{ batch.batch }}</div>
                    </b-col>
                    <b-col>
                      <div
                        class="font-poppins"
                        v-if="minPriceVisible || product.minCurrentMoneyVisible"
                      >
                        {{
                          minPriceVisible
                            ? product.min_price
                            : batch.selling_price
                        }}/=
                      </div>
                      <div class="font-poppins" v-else>
                        {{ batch.selling_price }}/=
                      </div>
                    </b-col>
                    <b-col>
                      <div class="font-poppins">
                        {{ batch.available_stock }}
                      </div>
                    </b-col>
                  </b-row>
                </div>
                <b-row v-show="batch.isBargained" class="mt-2 mb-4">
                  <b-col cols="12">
                    <b-card>
                      <b-row>
                        <!-- <b-col cols="8" class="text-left font-poppins">
                            Purchasing Price
                          </b-col>
                          <b-col cols="4" class="text-left font-poppins">
                            <b-badge variant="primary">
                              {{ batch.purchasing_price }} /=
                            </b-badge>
                          </b-col> -->
                        <!-- <b-col cols="8" class="text-left font-poppins">
                            Selling price
                          </b-col>
                          <b-col cols="4" class="text-left font-poppins">
                            <b-badge variant="primary">
                              {{ batch.selling_price }} /=
                            </b-badge>
                          </b-col> -->
                        <b-col cols="12" class="">
                          <div>
                            <div class="text-left font-poppins mb-2">
                              Discount
                            </div>
                            <b-input-group prepend="Rs" append="%" class="mb-2">
                              <!-- @input="AddBargainAmount($event, batchIndex)" -->
                              <b-form-input
                                @input="calculatePercentage(batch)"
                                ref="bargainedAmount"
                                autofocus
                                v-model="batch.bargained_amount"
                                placeholder="Amount"
                                type="number"
                                size="lg"
                              ></b-form-input>
                              <b-form-input
                                @input="calculateAmount(batch)"
                                v-model="batch.bargained_percentage"
                                ref="bargainedPercentage"
                                placeholder="Percentage"
                                type="number"
                                size="lg"
                              ></b-form-input>
                            </b-input-group>
                          </div>

                          <b-button
                            @click="selectBatch(batch, batchIndex)"
                            size="sm"
                            variant="primary"
                            class="mt-2 w-100"
                            >Submit</b-button
                          >
                        </b-col>
                      </b-row>
                    </b-card>
                  </b-col>
                </b-row>
              </div>
            </b-col>
            <b-col cols="2" class="pt-4">
              <b-form-checkbox
                size="lg"
                @input="focusAmountTextBox(batch.isBargained, batch)"
                v-model="batch.isBargained"
              >
              </b-form-checkbox>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { ProductModel } from "@/models/ProductModel";
import { SwipeList, SwipeOut } from "vue-swipe-actions";
import axios from "@/plugins/axios";
import "vue-swipe-actions/dist/vue-swipe-actions.css";
import { mapState, mapGetters } from "vuex";
export default {
  name: "PickProductUnitandBatch",
  created: function() {
    this.initialize();
  },
  methods: {
    isStockAvailable(data) {
      if (data) {
        const result = data.filter((item) => item.available_stock > 0);
        return result.length != 0;
      }
    },
    calculatePercentage(item) {
      if (this.minPriceVisible) {
        this.result = (item.bargained_amount / this.product.min_price) * 100;
      } else {
        this.result = (item.bargained_amount / item.selling_price) * 100;
      }
      if (this.result % 1 == 0) {
        item.bargained_percentage = this.result;
      } else {
        item.bargained_percentage = this.result.toFixed(2);
      }
    },
    calculateAmount(item) {
      if (this.minPriceVisible) {
        item.bargained_amount =
          (item.bargained_percentage * this.product.min_price) / 100;
      } else {
        item.bargained_amount =
          (item.bargained_percentage * item.selling_price) / 100;
      }
    },
    // AddBargainAmount(value, batchIndex) {
    // this.$store.commit("bill/ADD_BARGAIN_AMOUNT", {
    //   value,
    //   batchIndex,
    //   batchIndex: this.selectedbatchIndex,
    // });
    //   this.selectedBatch[batchIndex].bargained_amount = value;
    // },
    focusAmountTextBox(value, batch) {
      // batch.bargained_percentage = 0;
      // batch.bargained_amount = 0;
      if (value) {
        this.$refs.bargainedAmount[0].focus();
      }
    },
    initiate() {
      this.fetchCount = 0;
      this.product = Object.assign({}, ProductModel);
      this.selectedUnit = {};
      this.minPriceVisible = false;
      this.selectedBatch = {};
      this.selectedBatchIndex = {};
    },
    selectUnit(unit) {
      this.selectedUnit = unit;
    },
    selectBatch(batch, index) {
      this.selectedBatch = batch;
      if (
        batch.bargained_amount == undefined &&
        batch.bargained_percentage == undefined
      ) {
        batch.bargained_amount = 0;
        batch.bargained_percentage = 0;
      }
      this.selectedBatchIndex = index;
      // Available Stock
      axios
        .post(
          "pos/shops/" +
            this.shop_info.id +
            "/product/" +
            this.data.id +
            "/batch/" +
            this.selectedBatch.id +
            "/unit/" +
            this.selectedUnit.id,
          this.GetSelectedProductUnitsAndQuantity(this.data.id, 0)
        )
        .then((res) => {
          if (res.data?.data?.available_stock > 0) {
            this.$emit("addProduct", {
              batch: batch,
              unit: this.selectedUnit,
              available_stock: res.data.data.available_stock,
              setCurrentMoney: this.product.min_price,
              setCurrentMoneyVisible: this.minPriceVisible,
            });
            this.hideModal();
          } else {
            this.showToast("No Available Stock", "danger");
          }
        })
        .catch((err) => {});
    },
    showToast(message, variant = null) {
      this.$bvToast.toast(message, {
        title: `Message`,
        variant: variant,
        solid: true,
      });
    },
    fetchProduct() {
      this.loading = true;
      var productId = this.data.id;
      this.$store
        .dispatch("product/fetchUnitAndBatch", {
          productId: this.data.id,
          selectedUnits: this.GetSelectedProductUnitsAndQuantity(this.data.id),
        })
        .then((res) => {
          this.loading = false;
          if (res.status == 200) {
            this.product = res.data.data;
          } else if (res.status == 204) {
            this.product = Object.assign({}, ProductModel);
            this.product.name = this.data.name;
            this.reloadContent();
          }
        })
        .catch((err) => {
          this.loading = false;
          this.suspend_lists = [];
        });
    },
    reloadContent() {
      if (this.fetchCount < 2) {
        this.fetchProduct();
        this.fetchCount++;
      }
    },
    initialize() {
      this.loading = true;
      this.initiate();
      setTimeout(() => {
        this.fetchProduct();
      }, 200);
      // this.$refs["ModalUnitAndBatch"].show();
    },
    hideModal() {
      // this.$refs["ModalUnitAndBatch"].hide();
    },
    createUser() {},
  },
  props: {
    data: {
      type: Object,
      default: [],
    },
    selectedUnit: {
      type: String,
      default: [],
    },
    selectedBatch: {
      type: String,
      default: [],
    },
  },
  data: () => ({
    // dialog: false
    // tab: 0,
    loading: null,
    result: null,
    resut2: null,
    minPriceVisible: false,
    product: Object.assign({}, ProductModel),
    // selectedUnit: [],
    // selectedBatch: [],
    selectedBatchIndex: {},
    fetchCount: 0,
    mockSwipeList: [
      {
        id: 0,
        title: "Some title",
        description: "some description",
      },
      {
        id: 1,
        title: "Some title",
        description: "some description",
      },
      {
        id: 2,
        title: "Some title",
        description: "some description",
      },
    ],
  }),
  components: {
    SwipeOut,
    SwipeList,
  },
  computed: {
    ...mapState("shops", ["shop_info"]),
    ...mapGetters("bill", ["GetSelectedProductUnitsAndQuantity"]),
  },
  mounted: function() {
    // this.initialize();
  },
};
</script>

<style>
.unit,
.batch {
  font-family: "Poppins";
  font-weight: 600;
  padding: 20px 11px;
  border: 1px solid #634a00;
  border-radius: 11px;
  /* width: 200px; */
  text-align: center;
  box-shadow: 1px 1px 0px 0px black;
}
.selected {
  background-color: #ffc107;
  color: #162947;
  box-shadow: unset;
  border: 1px solid white;
}
.unit:hover,
.unit:active,
.batch:hover {
  background-color: #ffd557;
  border: 1px solid #ffd557;
  color: #162947;
}
</style>
